const initialState = { orders: null };

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ORDER":
      return {
        ...state,
        orders: action.data,
      };

    case "CREATE_ORDER": {
      let dt = state.orders.concat(action.data);
      return {
        ...state,
        orders: dt,
      }
    };
    case "UPDATE_ORDER": {
      let dt = state.orders.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        orders: dt,
      }
    };
    case "DELETE_ORDER": {
      let dt = state.orders.filter((a) => a._id !== action.data);
      return {
        ...state,
        orders: dt,
      };
    }
    default:
      return state;
  }
};

export default ordersReducer;
